import { render, staticRenderFns } from "./ProjectProfitForecast.vue?vue&type=template&id=19b620c2&"
import script from "./ProjectProfitForecast.vue?vue&type=script&lang=js&"
export * from "./ProjectProfitForecast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports